export default __webpack_public_path__ + "static/lloyds-echo-money-talks-experiment-5eadbe117a2e8bf44be92d6fa27767d3.png";